import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Container,
} from '@themesberg/react-bootstrap';
import { get, post, put } from '../../../services/back.service';
import ModalTriggerButton from '../../shared/ModalTriggerButton';

function ModalFormFuelTypes({
  fuelTypeSelect,
  callback,
  title,
  button_text,
  button_variant,
}) {
  const [show, setShow] = useState(false);
  const [infoForm, setForm] = useState({
    name: '',
    state: true,
  });

  const handleClose = () => setShow(false);
  const handleShow = async (fuelType) => {
    if (fuelType) {
      const infofuelType = await get('/catalog/fueltype/' + fuelType);
      if (infofuelType.success) {
        const { name, state } = infofuelType.data;
        setForm({
          name,
          state,
        });
      }
    }
    setShow(true);
  };

  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setForm({ ...infoForm, [target.name]: value });
  };

  const saveForm = async (e) => {
    let respo,
      variant = '',
      msg = '';

    const body = {
      name: infoForm.name,
      state: infoForm.state,
    };
    if (fuelTypeSelect) {
      respo = await put(
        '/catalog/fueltype/modify/' + fuelTypeSelect,
        body,
      );
      msg = 'Tipo editado Correctamente';
    } else {
      respo = await post('/catalog/fueltype/create', body);
      msg = 'Tipo Creado Correctamente';
    }

    if (respo.success) {
      variant = 'success';
    } else {
      variant = 'danger';
      msg = respo.message;
    }
    setForm({
      name: '',
      state: true,
    });
    handleClose();
    callback(variant, msg);
  };

  useEffect(() => {
    const initForm = () => {};

    initForm();
  }, []);

  return (
    <Fragment>
      <ModalTriggerButton
        button_variant={button_variant}
        button_text={button_text}
        onClick={() => handleShow(fuelTypeSelect)}
      />

      <Modal animation={false}  fullscreen="sm-down" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form.Label htmlFor="nombre">Nombre</Form.Label>
            <Form.Control
            className='mb-4' 
              name="name"
              value={infoForm.name}
              onChange={(e) => handleForm(e)}
              type="text"
            />
            <Form.Check
            className='mb-4'
              type="switch"
              name="state"
              label="Activo"
              checked={infoForm.state}
              onChange={(e) => handleForm(e)}
            />      
            <Row className="text-center mb-2">
              <Col className="buttons-container">
                <Button variant="secondary">Limpiar Formulario</Button>       
                <Button
                  type="submit"
                  variant="primary"
                  onClick={(e) => saveForm(e)}
                >
                  Guardar Informacion
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default ModalFormFuelTypes;
